/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonValidatorStakerListRequest = {
    validator?: string;
    sortDirection?: BabylonValidatorStakerListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace BabylonValidatorStakerListRequest {

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

